import Axios from 'axios';
import AxiosMiddleware from '../libs/AxiosMiddleware';
import Config from '../config';
import OPCODE from '../libs/OPCODE';
import _ from 'lodash';
import config from '../config';
import router from '../router';
import moment from 'moment';

export const TYPES = {
  UPDATE_SAIBS: 'UPDATE_SAIBS',
  CLEAR_NEW_SAIBS: 'CLEAR_NEW_SAIBS',
  CREATE_NEW_SAIBS: 'CREATE_NEW_SAIBS',
  UPDATE_DETAILS: 'UPDATE_DETAILS',
  SWITCH_SAIB: 'SWITCH_SAIB',
  SWITCH_ALL_SAIB: 'SWITCH_ALL_SAIB',
  REFRESH_CHECK_ALL: 'REFRESH_CHECK_ALL',
  UPDATE_EXCHANGES: 'UPDATE_EXCHANGES',
  REFRESH_LOGS: 'REFRESH_LOGS',
  CAN_APPLY: 'CAN_APPLY',
};

const state = {
  saibs: [],
  displayed: [],
  newSaibs: [],
  selected: [],
  indeterminate: false,
  selectedAll: false,
  isUpdate: false,
  exchanges: [],
  logs: {},
  saibsLog: [],
  totalLog: 0,
  displayedLogs: [],
  canApply: false,
};

const mutations = {
  [TYPES.REFRESH_CHECK_ALL](state) {
    state.selected = [];
    if (state.saibs.length === state.selected.length) {
      state.selectedAll = true;
      state.indeterminate = false;
    } else if (state.selected.length >= 1) {
      state.selectedAll = false;
      state.indeterminate = true;
    } else {
      state.selectedAll = false;
      state.indeterminate = false;
    }
  },
  [TYPES.UPDATE_SAIBS](state, res) {
    state.saibs = res;
  },
  [TYPES.CAN_APPLY](state, res) {
    state.canApply = res;
  },
  [TYPES.UPDATE_EXCHANGES](state, res) {
    state.exchanges = res;
  },
  [TYPES.REFRESH_LOGS](state, res) {
    state.totalLog = 0;
    res.forEach((v) => {
      if (v.status === 2) state.totalLog += v.detail.price;
    });

    state.saibsLog = _.uniqBy(res, 'uploadAt').map((a) => {
      state.logs[a.uploadAt] = [];
      return a.uploadAt;
    });

    for (const saib of res) state.logs[saib.uploadAt].push(saib);
    state.displayedLogs = res;
  },
  [TYPES.CLEAR_NEW_SAIBS](state, isUpdate = false) {
    state.isUpdate = isUpdate;
    state.newSaibs = [];
  },
  [TYPES.CREATE_NEW_SAIBS](state, newSaib) {
    state.newSaibs.push(newSaib);
  },
  [TYPES.UPDATE_DETAILS](state, { key, saib }) {
    state.newSaibs[key] = Object.assign(state.newSaibs[key], saib);
  },
  [TYPES.SWITCH_SAIB](state, idx) {
    const saib = state.saibs.find((v) => v.idx === idx);

    if (saib.status !== 0)
      return config.alert.mixin({
        type: 'warning',
        title: '접수되지 않는 사입 건만 선택이 가능합니다.',
      });

    if (state.selected.includes(idx)) {
      const index = state.selected.indexOf(idx);
      state.selected.splice(index, 1);
    } else {
      state.selected.push(idx);
    }

    if (state.saibs.length === state.selected.length) {
      state.selectedAll = true;
      state.indeterminate = false;
    } else if (state.selected.length >= 1) {
      state.selectedAll = false;
      state.indeterminate = true;
    } else {
      state.selectedAll = false;
      state.indeterminate = false;
    }
  },
  [TYPES.SWITCH_ALL_SAIB](state) {
    if (state.selectedAll || state.indeterminate) {
      state.selected = [];
    } else {
      for (const saib of state.saibs) {
        if (saib.status !== 0) continue;
        state.selected.push(saib.idx);
      }
    }

    if (state.saibs.length === state.selected.length) {
      state.selectedAll = true;
      state.indeterminate = false;
    } else if (state.selected.length >= 1) {
      state.selectedAll = false;
      state.indeterminate = true;
    } else {
      state.selectedAll = false;
      state.indeterminate = false;
    }
  },
};

const actions = {
  async viewContentsFromSaib(_, idx) {
    try {
      const { data } = await Axios.get(
        `${Config.hostname}/v1/saib/contents/${idx}`,
        {
          withCredentials: true,
        },
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this._vm.$info({
              title: '메세지',
              // eslint-disable-next-line no-unused-vars
              content: (h) => (
                <div>
                  <p>
                    <b>사입삼촌: </b>
                    {data.contents || '메세지가 없습니다.'}
                  </p>
                  <p>
                    <b>도매: </b>
                    {data.answer || '메세지가 없습니다.'}
                  </p>
                  <br />
                  <p>
                    <b>상세 설명: </b>
                    {data.details.map(({ name, reason }) => {
                      return (
                        <div>
                          <p style="margin-left: 0.75em">
                            <b>- {name}: </b>
                            {reason}
                          </p>
                        </div>
                      );
                    })}
                  </p>
                </div>
              ),
              okText: '완료',
            });
            break;
          default:
            this._vm.$error({
              title: '오류',
              content: '메세지를 가져올 수 없습니다.',
              okText: '완료',
            });
            break;
        }
      }
    } catch (err) {
      this._vm.$error({
        title: '오류',
        content: '메세지를 가져올 수 없습니다.',
        okText: '완료',
      });
    }
  },
  async addNewSaibs() {
    try {
      const fields = ['wholesale', 'price', 'details'];
      if (state.isUpdate) fields.push('idx');
      const saibs = _.map(state.newSaibs, _.partial(_.pick, _, fields));
      for (const { details } of saibs) {
        for (const detail of details) {
          if (!detail.name) {
            detail.name = '삼촌픽업예정';
          }

          if (!detail.amount) {
            detail.amount = 1;
          }
        }
      }

      const { data } = await Axios.post(
        `${Config.hostname}/v1/saib/apply`,
        { saibs },
        {
          withCredentials: true,
          params: {
            update: state.isUpdate,
          },
        },
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            router.push('/saib');
            this.dispatch('refreshMe');
            Config.alert.mixin({
              type: 'success',
              title: '성공적으로 추가했습니다.',
            });
            break;
          case OPCODE.UPDATE:
            router.push('/saib');
            Config.alert.mixin({
              type: 'success',
              title: '성공적으로 수정되었습니다.',
            });
            break;
          case OPCODE.NOT_ALLOW_TIME:
            Config.alert.mixin({
              type: 'warning',
              title: '현재는 사입을 접수할 수 없는 시간입니다.',
            });
            break;
          default:
            Config.alert.mixin({
              type: 'error',
              title: '알 수 없는 오류가 발생하였습니다.',
            });
        }
      }
    } catch (err) {
      Config.alert.mixin({
        type: 'error',
        title: '오류가 발생하였습니다.',
      });
    }
  },
  async refreshSaibs({ commit }) {
    const { data } = await Axios.get(`${Config.hostname}/v1/saib`, {
      withCredentials: true,
    });

    if (AxiosMiddleware(data.opcode)) {
      switch (data.opcode) {
        case OPCODE.SUCCESS:
          commit(TYPES.UPDATE_SAIBS, data.saibs);
          commit(TYPES.CAN_APPLY, data.canApply);
          commit(TYPES.REFRESH_CHECK_ALL);
          break;
      }
    }
  },
  createSaibs({ commit }, state) {
    commit(TYPES.CLEAR_NEW_SAIBS);
    for (const wholesale of state.wholesales) {
      const { idx, name, location } = wholesale;

      if (!state.selected.includes(idx)) continue;

      commit(TYPES.CREATE_NEW_SAIBS, {
        wholesale: idx,
        name,
        location,
        price: 0,
        details: [{ name: '', amount: 1 }],
      });
    }
  },
  async getSaibsEdit({ commit }) {
    if (state.selected.length <= 0) {
      return Config.alert.mixin({
        type: 'error',
        title: '사입을 최소 1개 이상 선택하여야 합니다.',
      });
    }

    commit(TYPES.CLEAR_NEW_SAIBS, true);
    for (const idx of state.selected) {
      const saib = state.saibs.find((v) => v.idx === idx);

      if (!saib) continue;
      commit(TYPES.CREATE_NEW_SAIBS, {
        idx: saib.idx,
        wholesale: saib.wholesale.idx,
        name: saib.wholesale.name,
        location: saib.wholesale.location,
        price: saib.price,
        details: saib.details,
      });
    }
    router.push('/saib/edit');
  },
  async deleteSaibs({ dispatch }) {
    const saibs = state.selected;
    if (saibs.length <= 0) {
      return Config.alert.mixin({
        type: 'error',
        title: '사입을 최소 1개 이상 선택하여야 합니다.',
      });
    }

    this._vm.$confirm({
      title: '사입 삭제',
      content: `정말로 ${saibs.length} 개의 사입을 삭제하시겠습니까? 이후에 취소할 수 없습니다.`,
      okText: '네, 삭제합니다.',
      cancelText: '아니요',
      async onOk() {
        try {
          const { data } = await Axios.delete(`${Config.hostname}/v1/saib/`, {
            withCredentials: true,
            data: { saibs },
          });

          if (AxiosMiddleware(data.opcode)) {
            switch (data.opcode) {
              case OPCODE.SUCCESS:
                Config.alert.mixin({
                  type: 'success',
                  title: '성공적으로 삭제되었습니다.',
                });
                dispatch('refreshSaibs');
                break;
            }
          }
        } catch (err) {
          Config.alert.mixin({
            type: 'error',
            title: '오류가 발생하여 삭제할 수 없습니다.',
          });
        }
      },
    });
  },
  async refreshExchanges({ commit }) {
    const { data } = await Axios.get(`${Config.hostname}/v1/exchange`, {
      withCredentials: true,
    });

    if (AxiosMiddleware(data.opcode)) {
      switch (data.opcode) {
        case OPCODE.SUCCESS:
          commit(TYPES.UPDATE_EXCHANGES, data.exchanges);
          break;
      }
    }
  },
  async refreshLogs({ commit }, search) {
    const { data } = await Axios.post(`${Config.hostname}/v1/logs`, search, {
      withCredentials: true,
    });

    if (AxiosMiddleware(data.opcode)) {
      switch (data.opcode) {
        case OPCODE.SUCCESS:
          commit(TYPES.REFRESH_LOGS, data.logs);
          break;
      }
    }
  },
  async downloadLogs() {
    const { data } = await Axios.post(
      `${Config.hostname}/v1/logs/generate`,
      { items: _.map(state.displayedLogs, 'idx') },
      { responseType: 'blob', withCredentials: true },
    );

    const objectUrl = window.URL.createObjectURL(data);
    const linkElement = document.createElement('a');
    linkElement.href = objectUrl;
    linkElement.setAttribute(
      'download',
      `Log-${moment().format('YYYY-MM-DD-HH:mm:ss')}.xlsx`,
    );
    document.body.appendChild(linkElement);
    linkElement.click();
  },
};

const getters = {};

export default { state, mutations, getters, actions };
